import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import style from "../../assets/css/modules/health-support/health-support.css";
import { Layouts } from "../../constants/Constants";
import {
  nonFastTrackModules,
  travelOrEapModules
} from "../../constants/SMEModulesToMatchOn";
import { Paths } from "../../constants/UrlConstants";
import Content from "../../content/Content";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import {
  shouldShowIfAllSMEModulesDontMatch,
  shouldShowIfAllSMEModulesMatch
} from "../../helpers/SMEModules/smeModuleHelper";
import HomeCard from "../home/HomeCard";
import GenericHero from "../shared/GenericHero";
import HelpSection from "../shared/HelpSection";
import HealthSupportItem from "./HealthSupportItem";
import { _gpAppointmentsLink,_physiotherapistLink,_workingBodyLink } from "../../content/HealthSupport";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";

const stripGP247 = (isChildOnlyPolicy, links, isAgeAbove18, isHOL,isLapsed) => {
  if (isChildOnlyPolicy) {
    Object.keys(links).forEach(k => {
      links[k] = links[k]?.filter && links[k]?.filter(i => i !== _gpAppointmentsLink);
    });
  }

  if(!isAgeAbove18 || isLapsed)
    {
      Object.keys(links).forEach(k => {
        links[k] = links[k]?.filter && links[k]?.filter(i => i !== _workingBodyLink);
      });
    }

    if(isHOL === true && !isAgeAbove18 )
      {
        Object.keys(links).forEach(k => {
          links[k] = links[k]?.filter && links[k]?.filter(i => i !== _physiotherapistLink);
        });
      }

  return links;
};

export const mapStateToHealthSupport = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
  const isInternational = selectedPolicy && selectedPolicy.IsInternational;
  const isLapsed = selectedPolicy && selectedPolicy.IsLapsed;
  const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(loggedInMember.DateOfBirth);
  return {
    shouldShowFastTrack: shouldShowIfAllSMEModulesDontMatch(
      selectedPolicy,
      nonFastTrackModules
    ),
    shouldShowSpeakToTeam: !shouldShowIfAllSMEModulesMatch(
      selectedPolicy,
      travelOrEapModules
    ),
    CurrentPolicy: selectedPolicy,
    isLapsed,
    isInternational,
    isAgeAbove18,
    layout: state.layoutReducer && state.layoutReducer.layout,
    TelephonePolicyServicing:
      selectedPolicy &&
      selectedPolicy.PolicyServicingTelephones &&
      selectedPolicy.PolicyServicingTelephones.TelephonePolicyServicing,
    IsSMEModular: selectedPolicy && selectedPolicy.IsSMEModular,
    IsChildOnlyPolicy: selectedPolicy.IsChildOnlyPolicy
  };
};

export const HealthSupport = function (props) {
  const isHOL = props.layout === Layouts.HOL;

  let helpSet = [Store.HealthSupport.AskMedicalExpert];

  if (props.shouldShowFastTrack) {
    helpSet.push(Store.HealthSupport.BookFastTrackAppointment);
  }

  if (props.isInternational || ((props.isLapsed) && !window?.axa?.features?.healthUnlockedFeature)) {
    return <Redirect to={Paths.AskAMedicalExpert} />;
  } else if ((props.isLapsed) && window?.axa?.features?.healthUnlockedFeature) {
    return <Redirect to={Paths.HealthInformation} />;
  } else {
    return (
      <React.Fragment>
        <div className={`home ${style.healthSupport}`}>
          <GenericHero
            HeroBG={Store.HealthSupport.HeroContent.HealthSupportBannerSrc}
            HeroBGMobile={
              Store.HealthSupport.HeroContent.HealthSupportBannerSrcMobile
            }
            Heading={Store.HealthSupport.HeroContent.Heading}
            DarkOverlay={false}
            ExtraClasses={style.removeBoxPaddingAtBottom}
            backgroundColor="#070E40"
          >
            <h2 className={style.header} data-hero-header>
              {props.content.HeroContent.Header}
            </h2>
            <p data-hero-body>{props.content.HeroContent.Body}</p>
            <div className={style.healthSupportItemsSection}>
              {(props.shouldShowFastTrack
                ? props.content.HealthSupportItems
                : props.content.HealthSupportItemsWithoutFasttrack
              ).map((item, key) => (
                <HealthSupportItem
                  key={key}
                  IconSrc={item.IconSrc}
                  Heading={item.Heading}
                  Desc={item.Desc}
                  Links={stripGP247(props.IsChildOnlyPolicy, item.Links,props.isAgeAbove18,isHOL,props.isLapsed)}                  
                  Flag = {item.HeadingFlag}
                />
              ))}
            </div>
            <HelpSection
              HeadingLinkTo={Paths.Help}
              HeadingLinkText={Store.GeneralPages.HelpHeadingLinkText}
              MoreHelpLinkTo={Paths.Help}
              MoreHelpLinkText={Store.GeneralPages.MoreHelpLinkText}
              HelpSet={helpSet}
            />
          </GenericHero>
          {(!isHOL ? 
          <div className="container">
            <div className="row">
              <div
                className={
                  props.shouldShowSpeakToTeam ? "col-sm-12 col-lg-6" : "col-12"
                }
                data-contactus
              >
                <Content
                  names={[
                    Store.HealthSupport.Cards.ContactUs.IconSrc,
                    Store.HealthSupport.Cards.ContactUs.Heading,
                    Store.HealthSupport.Cards.ContactUs.Description,
                    Store.HealthSupport.Cards.ContactUs.LinkText,
                    Store.HealthSupport.Cards.ContactUs.LinkTo,
                    Store.HealthSupport.Cards.ContactUs.id
                  ]}
                >
                  {(iconSrc, heading, description, linkText, linkTo,id) => (
                    <HomeCard
                      IconSrc={iconSrc}
                      Heading={heading}
                      Description={description}
                      LinkText={linkText}
                      LinkTo={linkTo}
                      id={id}
                    />
                  )}
                </Content>
              </div>
              {props.shouldShowSpeakToTeam && (
                <div className="col-sm-12 col-lg-6" data-healthsupport>
                  <Content
                    names={[
                      Store.HealthSupport.Cards.SpeakToTeam.IconSrc,
                      Store.HealthSupport.Cards.SpeakToTeam.Heading,
                      Store.HealthSupport.Cards.SpeakToTeam.Description
                    ]}
                    params={{
                      telephoneNumber: props.TelephonePolicyServicing
                    }}
                  >
                    {(iconSrc, heading, description) => (
                      <HomeCard
                        IconSrc={iconSrc}
                        Heading={heading}
                        Description={description}
                      />
                    )}
                  </Content>
                </div>
              )}
            </div>
          </div>
           :"")}
        </div>
      </React.Fragment>
    );
  }
};
HealthSupport.content = Store.HealthSupport;

export default Contentify(connect(mapStateToHealthSupport)(HealthSupport));
